'use strict';
var global = require('../internals/global');

var globalIsFinite = global.isFinite;

// `Number.isFinite` method
// https://tc39.es/ecma262/#sec-number.isfinite
// eslint-disable-next-line es/no-number-isfinite -- safe
module.exports = Number.isFinite || function isFinite(it) {
  return typeof it == 'number' && globalIsFinite(it);
};



//////////////////
// WEBPACK FOOTER
// ./~/recharts/~/core-js/internals/number-is-finite.js
// module id = 990
// module chunks = 0